import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveExtracurricularPayload } from "../types/extracurricularType";

export const getExtracurricularList = createAsyncThunk("/extracurricular/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/extracurriculars?${query.toString()}`)).data;
  return response;
});

export const getExtracurricularDetail = createAsyncThunk("/extracurricular/detail", async (slug: string) => {
  const response = (await api.get(`/extracurriculars/${slug}`)).data;
  return response;
});

export const saveExtracurricular = createAsyncThunk("/extracurricular/save", async (payload: SaveExtracurricularPayload) => {
  const response = (await api.post("/extracurriculars/action", payload)).data;
  return response;
});

export const deleteExtracurricular = createAsyncThunk("/extracurricular/delete", async (id: number) => {
  const response = (await api.get(`/extracurriculars/delete/${id}`)).data;
  return response;
});
